export interface AttachedDocument {
  file: File;
  documentType: string;
  description: string;
}

export interface AddIssueForm {
  issueId: string;
  issueStatus: string;
  issueTitle: string;
  reviewObjective: string;
  issueDescription: string;
  recommendation: string;
  rcReviewer: string;
  rcSupervisor: string;
  rcManager: string;
  locationsImpacted: string[];
  broadCategory: string;
  detailedCategory: string;
  identificationDate: string;
  subscribers: string[];
  subscriberSearch: string;
  rcCommentsForIssue: string;
  actionRequiredBy: string;
  riskStatement: string;
  repLetterConflict: string;
  repLetterQuestionsWithConflict: string[];
  financialYear: string;
  quarter: string;
  issueRating: string;
  serviceLines: string[];
  issueCloseDueDate: string;
  reportStatus: string;
  issueFromGoLive: string;
  legacyIssueNumber: string;
}

export interface RiskCategoryRow {
  broadCategory: string;
  detailedCategory: string;
  riskStatement: string;
}

export interface ExistingFile {
  FileName: string;
  StorageFilePath: string;
  FileSize?: number;
  FileType?: string;
  fileContent?: string;
}

export interface ActionPlanRow {
  id: string;
  description: string;
  owner: string;
  targetDate: string;
  status: string;
  linkedIssues: string;
  linked: boolean;
  closedDate?: string;
  rcComments?: string;
}

export interface ActionPlanForm {
  id: string;
  description: string;
  closedDate: string;
  internalDependencies: string[];
  targetDate: string;
  owners: string[];
  status: string;
  revisedTargetDate: string;
  rcComments: string;
  clientDependency: string;
  redClientInformedDate: string;
  targetDateToInformRedClient: string;
  legacyApNumber: string;
}

export function createDefaultActionPlanForm(): ActionPlanForm {
  return {
    id: '',
    description: '',
    closedDate: '',
    internalDependencies: [],
    targetDate: '',
    owners: [],
    status: '',
    revisedTargetDate: '',
    rcComments: '',
    clientDependency: '',
    redClientInformedDate: '',
    targetDateToInformRedClient: '',
    legacyApNumber: '',
  };
}

export function createDefaultAddIssueForm(): AddIssueForm {
  return {
    issueId: '',
    issueStatus: 'Draft',
    issueTitle: '',
    reviewObjective: '',
    issueDescription: '',
    recommendation: '',
    rcReviewer: '',
    rcSupervisor: '',
    rcManager: '',
    locationsImpacted: [],
    broadCategory: '',
    detailedCategory: '',
    identificationDate: '',
    subscribers: [],
    subscriberSearch: '',
    rcCommentsForIssue: '',
    actionRequiredBy: '',
    riskStatement: '',
    repLetterConflict: '',
    repLetterQuestionsWithConflict: [],
    financialYear: 'FY26',
    quarter: 'Q1',
    issueRating: '',
    serviceLines: [],
    issueCloseDueDate: '',
    reportStatus: '',
    issueFromGoLive: '',
    legacyIssueNumber: '',
  };
}